<template>
  <div class="message">
    Se o download não ocorrer automaticamente, <a @click="getSlip">clique aqui.</a>
  </div>
</template>
<script>
import getSlipUrl from '@/services/getSlipUrl'

export default {
  created() {
    this.getSlip()
  },
  methods: {
    getSlip() {
      if (this.$route.params.q) {
        const { hash } = JSON.parse(this.$route.params.q)
        window.location = getSlipUrl(decodeURIComponent(hash))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
    text-align: center;
    margin: 20%;
    font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// ./src/views/SlipPreview.vue